module.exports = __webpack_public_path__ + "img/smm_tw1.44eeec77.png";